import React from 'react';

export const HR = ({size = "1", width = "100%", color = "lightgrey", className =""}) =>{
    return (<hr size={size} width={width} color={color} className={className}/>)
}
